var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTextsection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "38px",
    viewBox: "0 0 35 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "38495BB2-460A-4960-9104-1AFCDD8BEBA3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CMS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Products---detail--add-section",
    transform: "translate(-573.000000, -328.000000)",
    stroke: "#E10210",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(510.000000, 306.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    transform: "translate(64.500000, 23.485806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5,0 L10,0 C4.47715255,0 0,4.47715275 0,10 L0,25 C0,30.5228469 4.47715255,35 10,35 L22.5,35 C28.0228471,35 32.5,30.5228469 32.5,25 L32.5,10 C32.5,4.47715275 28.0228471,0 22.5,0 Z",
    id: "Vector-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.75,10 L8.75,10 M23.75,17.5 L8.75,17.5 M16.25,25 L8.75,25",
    id: "Vector-3"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextsection);
export default __webpack_public_path__ + "static/media/Text section.d0a4b29267638ab4161beea5db8981ab.svg";
export { ForwardRef as ReactComponent };